import script from "./Stato.vue?vue&type=script&setup=true&lang=js"
export * from "./Stato.vue?vue&type=script&setup=true&lang=js"

import "./Stato.vue?vue&type=style&index=0&id=922454fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-922454fa"]])

export default __exports__